import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { UrlConfig } from './../../../config/url-config';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatMenuModule
  ],
  declarations: [
    HeaderComponent
  ],
  providers: [
    UrlConfig
  ],
  exports: [
    HeaderComponent
  ]
})
export class HeaderModule {}
